import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FilesListComponent } from './files-list.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { FilesService } from './files.service';

@Component({
    selector: 'convfact-filedownload',
    templateUrl: './files-dialog-download.html',
    styleUrls: ['./files.component.css'],
    standalone: false
})

export class FilesDialogDownloadComponent {

    constructor(
        public dialogRef: MatDialogRef<FilesListComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public filesService: FilesService
    ) { }

    url: string = this.data.url;
    note: string = this.data.note;

    downloadFile() {
        window.open(this.url, '_blank');
        this.closeDialog();
    }
    closeDialog() {
        this.dialogRef.close();
    }

}
